export default __webpack_public_path__ + "static/media/lighweight-ml.794bfd69.png";